import { apiClient } from "../../../api/httpClient";

export function patchGuardianAddressRow(guardians, index, keys, patch) {
  const updated = Array.isArray(guardians) ? [...guardians] : [];
  updated[index] = { ...updated[index], ...patch };
  return updated;
}

export async function fetchCityStateByZip(zipCode, zipLookupMode) {
  if (zipLookupMode === "zip-code") {
    const response = await apiClient(`/zip-code/${zipCode}`, "GET");
    return response ? { city: response.city, state: response.state } : null;
  }
  const response = await apiClient(`/fields/location/${zipCode}`, "GET");
  return { city: response.city, state: response.state };
}
